import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Terms & Conditions - Mauli Cabs",
    "url": "https://www.maulicabs.com/terms-and-conditions",  // Replace with actual URL
    "description": "Read the terms and conditions for using Mauli Cabs’ services including booking policies, cancellation, liability, and passenger responsibilities."
  };
  
 
  return (
    <div>

<section
  className="vs-breadcrumb"
  style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
>
  

  <div className="container">
    <div className="row text-center">
      <div className="col-12">
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">Terms & Conditions</h1>
        </div>
      </div>
    </div>
  </div>
</section> 

<Helmet>
    <title>Terms & Conditions | Mauli Cabs | Mumbai to Pune Taxi Policy</title>
    <meta
      name="description"
      content="Review Mauli Cabs’ Terms & Conditions for taxi bookings. Learn about our policies on booking, cancellations, refunds, and your responsibilities as a passenger."
    />
    <meta
      name="keywords"
      content="mauli cabs terms and conditions, taxi booking policy, cab service rules, mauli cabs cancellation policy, refund terms, passenger policy mauli cabs, cab booking agreement, mumbai to pune taxi terms, safe travel policy, mauli cabs user agreement"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <section
        className="bg-cover position-relative"
        style={{
          background: 'url(/img/bg-title.jpg) no-repeat',
        }}
        data-overlay="5"
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-xl-7 col-lg-9 col-md-12">
              <div className="fpc-capstion text-center my-4">
                <div className="fpc-captions">
                  <h1 className="xl-heading text-light">Terms & Conditions</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings made with Mauli Cab are subject to availability and will be confirmed upon full payment and issuance of a booking reference number.</p>

                <p><b className="highlight">2. Payment:</b> Payment must be completed at the time of booking through our secure online platform or other authorized payment channels.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Booking modifications or cancellations must adhere to our cancellation policy, and applicable charges may apply based on the timing of the request.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers are required to carry valid identification and booking confirmations. Mauli Cab reserves the right to refuse service if documentation is not provided.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Passengers are allowed limited baggage per booking. Any additional or oversized baggage may attract extra charges and should be pre-confirmed during the booking process.</p>

                <p><b className="highlight">6. Travel Insurance:</b> We recommend passengers obtain travel insurance for protection against unforeseen events, although Mauli Cab ensures the safest travel environment possible.</p>

                <p><b className="highlight">7. Safety Regulations:</b> All passengers must comply with safety regulations and follow the driver’s instructions. Non-compliance may result in service denial without a refund.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> Mauli Cab reserves the right to adjust the itinerary, routes, or schedules due to weather conditions, road closures, or other unexpected circumstances. We will try to communicate changes in advance wherever possible.</p>

                <p><b className="highlight">9. Refusal of Service:</b> Service may be refused to passengers who display unruly behavior, violate our terms, or pose a risk to the safety of other passengers or the driver.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms and conditions are governed by Indian law, and any disputes will fall under the jurisdiction of Pune courts.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Book your cab conveniently via our website, mobile app, or customer service helpline for a smooth experience.</p>
                <p><b className="highlight">Customer Support:</b> Our dedicated support team is available 24/7 to assist with queries, feedback, and support needs. We aim for quick and satisfactory resolutions.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Fees:</b> Refunds are subject to applicable cancellation fees, which depend on how early the cancellation request is made, as explained during the booking process.</p>
                <p><b className="highlight">Refund Process:</b> Refunds will be processed within 7–10 business days via the original payment method. For any delays or issues, please contact our support team for assistance.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows are not eligible for refunds or rescheduling. It is mandatory to inform Mauli Cab at least 24 hours in advance for cancellations or changes to avoid penalties.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any queries or require clarification regarding our terms, feel free to contact us:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+917972733209">+91 7972733209</a></li>
              <li><b>Email:</b> <a href="mailto:booking@maulicab.com">booking@maulicab.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
